import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'
import React, { useEffect, useState } from 'react'
// eslint-disable-next-line
import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times-chip.svg'
import { InputMask } from '@/components/InputMask/InputMask'

import './BYODModal.scoped.sass'
import signupService from '@/app-domains/user/onboarding/signup.service'
import { PhoneInputComponent } from './PhoneInputComponent/PhoneInputComponent.jsx'
import TimezoneSelect from 'react-timezone-select'
import onboardingService from '@/app-domains/onboarding/onboarding.service'
import sessionService from '@/app-domains/user/session/session.service'

export function BYODModal (props) {
  const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)
  const [phoneNumber, setPhoneNumber] = useState()
  const [oldDomain, setOldDomain] = useState()
  const [BYODRequestEnabled, setBYODRequestEnabled] = useState(false)
  async function userAcceptedJoiningBoxesWithBYOD () {
    if (oldDomain !== undefined && phoneNumber !== undefined && timezone !== undefined) {
      modalService.close()
      await onboardingService.postBYODData(oldDomain, phoneNumber, timezone)
      if (props.closeInsteadOfRedirect) {
        // Reload me info
        sessionService.setMeInfo()
      } else {
        signupService.travelToNextPageInBYODMode()
      }
    }
  }

  useEffect(() => {
    if (oldDomain !== undefined && phoneNumber !== undefined && timezone !== undefined) {
      setBYODRequestEnabled(true)
    }
  }, [timezone, oldDomain, phoneNumber])

  return (<div className='byod-modal'>
    <div className='byod-header'>
      <div>
        <p className='main-phrase'>Bring your own domain to Boxes!</p>
        <p className='main-subphrase'>Enjoy all the Boxes features using your already existing domain</p>
      </div>
      <div className='close-icon' onClick={() => modalService.close()}><CrossIcon/></div>
    </div>
    <div className='byod-content'>
      <p>
        In order to bring your domain to Boxes you'll need the following:
      </p>
      <div className='info-div'>
        <div className='field-div'>
          <InputMask placeholder='Domain...' label="What's your domain?" value={oldDomain} onInput={setOldDomain} />
        </div>
        <div className='field-div phone'>
          <label className='phone-label'>What's your phone number?</label>
          <br/>
          <label style={{ fontSize: '12px' }}className='phone-label'>( Include your country code, e.g. USA numbers start with 1 )</label>
          <PhoneInputComponent phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} />
        </div>
        <div className='field-div timezone'>
          <label className='timezone-label'>What's your timezone?</label>
          <div className='timezone-div'>
            <TimezoneSelect value={timezone} onChange={setTimezone} labelStyle="altName" />
          </div>
        </div>
      </div>
      <p>
      </p>
    </div>
    <div className='cancel-actions'>
      <div className='close-cancel'>
        <Button content="Start setup" type='primary' click={userAcceptedJoiningBoxesWithBYOD} disabled={!BYODRequestEnabled}/>
      </div>
    </div>
  </div>)
}
